import { render, staticRenderFns } from "./patient_manager_info_note.vue?vue&type=template&id=ae5109a4&scoped=true"
import script from "./patient_manager_info_note.vue?vue&type=script&lang=js"
export * from "./patient_manager_info_note.vue?vue&type=script&lang=js"
import style0 from "./patient_manager_info_note.vue?vue&type=style&index=0&id=ae5109a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5109a4",
  null
  
)

export default component.exports